import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../../../style/pages/HomePage.css';

// Mismo patrón de tarjetas de acceso que Inicio, ART, RTI y Reportes de trámites (acceso-card en
// HomePage.css), una por vista y cada una con su color.
const SECCIONES = [
    {
        id: 'resumen', ruta: '/reportes/recepcion', titulo: 'Resumen', icono: 'bi-clipboard-data', variante: 'acceso-card-rti',
        descripcion: 'Lo esencial del período: asistencia, conversión, resultados y turnos por día.',
    },
    {
        id: 'pro', ruta: '/reportes/recepcion/pro', titulo: 'Estadísticas Pro', icono: 'bi-graph-up-arrow', variante: 'acceso-card-turnero',
        descripcion: 'Análisis completo: ocupación, embudo, tendencias y operadores.',
    },
    {
        id: 'bot', ruta: '/reportes/recepcion/bot', titulo: 'Estadísticas del bot', icono: 'bi-robot', variante: 'acceso-card-art',
        descripcion: 'El resumen, solo con los turnos que llegaron por el bot.',
    },
    {
        id: 'historicas', ruta: '/reportes/recepcion/historicas', titulo: 'Históricas', icono: 'bi-clock-history', variante: 'acceso-card-agenda',
        descripcion: 'Turnos del sistema más la planilla manual (mayo a agosto de 2026).',
    },
];

/**
 * Tarjetas para moverse entre las vistas de Reportes Recepción. La vista actual queda marcada y no
 * navega.
 * @param {{activa: 'resumen'|'pro'|'bot'|'historicas'}} props
 */
export default function NavegacionReportesRecepcion({ activa }) {
    const navigate = useNavigate();

    const ir = (seccion) => {
        if (seccion.id !== activa) navigate(seccion.ruta);
    };

    return (
        <nav aria-label="Vistas de Reportes Recepción" className="accesos-reportes-recepcion">
            {SECCIONES.map((seccion) => {
                const esActiva = seccion.id === activa;
                return (
                    <div
                        key={seccion.id}
                        role="link"
                        tabIndex={esActiva ? -1 : 0}
                        aria-current={esActiva ? 'page' : undefined}
                        className={`acceso-card ${seccion.variante}${esActiva ? ' acceso-card-activa' : ''}`}
                        onClick={() => ir(seccion)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                ir(seccion);
                            }
                        }}
                    >
                        <div className="acceso-card-icon"><i className={`bi ${seccion.icono}`} /></div>
                        <div className="acceso-card-body">
                            <h5>{seccion.titulo}</h5>
                            <p>{seccion.descripcion}</p>
                        </div>
                        {esActiva
                            ? <span className="acceso-card-actual">Estás acá</span>
                            : <i className="bi bi-arrow-right-short acceso-card-arrow" />}
                    </div>
                );
            })}
        </nav>
    );
}
